import type {
  EvaluateKillSwitchRequest,
  EvaluateKillSwitchResponse,
} from "@b2bportal/hsbc-feature-flags-api";
import { trackEvent, axiosInstance } from "@hopper-b2b/api";
import type { IKillSwitchResponse, IApiConfig } from "@hopper-b2b/types";
import { NETWORK_CALL_FAILED } from "@hopper-b2b/types";

import { killSwicthApiPrefix } from "./paths";

/**
 * Example to use this is
 *  postEvaluateKillSwitch(KillSwitchNames.DISRUPTION_SELF_SERVE_REBOOK).then(
    (response) => {
      console.log(
        "DisruptionExercise I am in!! and value of kill switch is: " +
          response.isKillSwitchOn
      );
    }
  );
 *
 * @param featureFlagName
 * @param config
 * @returns
 */
export const postEvaluateKillSwitch = async (
  featureFlagName: string,
  config?: IApiConfig
): Promise<IKillSwitchResponse> => {
  const END_POINT = `${killSwicthApiPrefix}/evaluate`;

  try {
    const req: EvaluateKillSwitchRequest = {
      featureFlagName: featureFlagName,
    };
    const res = await axiosInstance.post<EvaluateKillSwitchResponse>(
      END_POINT,
      req
    );

    const killSwitchIsOn =
      res.data.evaluatedFeatureFlag?.variant === "Available";
    return {
      isKillSwitchOn: killSwitchIsOn,
    };
  } catch (e) {
    trackEvent(
      {
        eventName: NETWORK_CALL_FAILED,
        properties: {
          url: window.location.pathname,
        },
      },
      config
    );
    throw e;
  }
};
